
import React,{useState} from 'react';
import styled from 'styled-components';
import { CONSTS } from '../components/elements/_constants';
import { Button, ComponentModesEnum } from '../components/elements';
import QCLabLogo from './../static/img/qclab-logo-white.svg'
import Axios from 'axios';
import { BASE_URL } from '../inc/constants';
import { setToken, setUser, setLab } from '../store/base/functions';
import { useHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { AppState } from '../store';
import IMGThreeDots from '../static/img/three-dots.svg';
import IMGLoginBG from '../static/img/login-bg.png';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
enum AuthStateEnum {
   Login="login",
   ForgetPassword="forget-password"
}
const LoginPage = (props: any) => {
   const [authState, setauthState] = useState<AuthStateEnum>(AuthStateEnum.Login);
   const [phone, setphone] = useState<any>()
   const [pass, setpass] = useState<any>()
   const [isLoading, setisLoading] = useState(false)
   let history = useHistory()
   const login = (e:any)=> {
      e.preventDefault();
      setisLoading(true);
      Axios.post(`${BASE_URL}/auth-login/`,{password:pass,username:phone})
      .then(r=>{
         props.onSetToken(r.data.token);
         props.onSetUser(r.data.user);
         props.onSetLab(r.data.lab);
         setisLoading(false);
      })
      .then(()=>{
         history.push("/");
      })
      .catch(e => {
            console.log(e);
            alert('تلفن همراه یا رمزعبور نادرست است.');
            setisLoading(false);
         }
      )
   }
   const forgetPassword = (e:any)=> { //TODO: add forget pass request
      e.preventDefault();
      setisLoading(true);
      Axios.post(`${BASE_URL}/auth-login/`,{password:pass,username:phone})
      .then(r=>{
         props.onSetToken(r.data.token);
         props.onSetUser(r.data.user);
         props.onSetLab(r.data.lab);
         setisLoading(false);
      })
      .then(()=>{
         history.push("/");
      })
      .catch(e => {
            console.log(e);
            alert('تلفن همراه یا رمزعبور نادرست است.');
            setisLoading(false);
         }
      )
   }
  return (
    <div className={props.className}>
       <div className="_main-box">

         <div className="login-box">
         <SwitchTransition>
               <CSSTransition
                     key={""+authState}
                     timeout={{ enter: 280, exit: 280 }}
                     classNames="fade"
               >
                  <>
                        <div className="login-card">
                           <div className="_title-bar">
                              {authState==AuthStateEnum.Login ? "ورود به ناحیه کاربری" : "بازیابی رمز عبور"}
                           </div>
                        

                           <form onSubmit={authState==AuthStateEnum.Login ?  login : forgetPassword}>

                              <input onChange={(e)=>setphone(e.target.value)} value={phone} placeholder="تلفن همراه" type="phone" required/>
                              
                                       {authState==AuthStateEnum.Login && <input onChange={(e)=>setpass(e.target.value)} value={pass} placeholder="رمز عبور" type="password" required/>}
                                    

                              {!isLoading ? 
                              authState==AuthStateEnum.Login ?
                                 <Button type="submit" mode={ComponentModesEnum.Primary} style={{width:'100%',marginTop:10,fontSize:17,fontWeight:500}}>ورود</Button>
                                 : 
                                 <Button type="submit" mode={ComponentModesEnum.Primary} style={{width:'100%',marginTop:10,fontSize:17,fontWeight:500}}>دریافت رمزعبور جدید</Button>
                              : <Button type="button" mode={ComponentModesEnum.Info} style={{width:'100%',marginTop:10,fontSize:17,fontWeight:500}}>
                                    <img src={IMGThreeDots} height="8px"/>
                              </Button>}

                           </form>
                        </div>
                        {authState==AuthStateEnum.Login ?
                           <Button type="button" onClick={()=>setauthState(AuthStateEnum.ForgetPassword)} mode={ComponentModesEnum.Primary} style={{width:'100%',marginTop:10,fontSize:13,fontWeight:200}}>
                              فراموشی رمز عبور
                           </Button>
                        :
                           <Button type="button" onClick={()=>setauthState(AuthStateEnum.Login)} mode={ComponentModesEnum.Primary} style={{width:'100%',marginTop:10,fontSize:13,fontWeight:200}}>
                              ورود به ناحیه کاربری
                           </Button>
                        }
                        </>
                     </CSSTransition>
                  </SwitchTransition>
            <div className="responsive-call-button">
               <Button type="button" mode={ComponentModesEnum.Primary} onClick={()=>window.open('tel:09388951610')} style={{width:'100%',marginTop:10,fontSize:13,fontWeight:200}}>
                  درخواست پنل 
               </Button>
            </div>
         </div>

         <div className="introduction">
            <img src={QCLabLogo}/>
            <div className="portal-title">
               پرتال یکپارچه استانداردسازی آزمایشگاه‌های پزشکی
            </div>
            <div className="portal-description">
               تمامی مدارک و مستندات مورد نیاز برای تمامی آزمایشگاه‌های تشخیص طبی و پاتوبیولوژی مطابق آخرین
                <b>{" "}
                ویرایش (۱۳۹۸) 
                {" "}</b>
                در یک سامانه
            </div>
            <div className="call-button" onClick={()=>window.open('tel:09388951610')}>
               درخواست پنل 
            </div>
         </div>
       </div>
    </div>
  );
}
const Login = styled(LoginPage)`
   background-size: cover;
   width: 100vw;
   height: 100vh;
   display: flex;
   align-content: center;
   align-items: center;
   justify-content: center;
   flex-direction: column;
   &::after {
      content: "";
      background-image: url(${IMGLoginBG});
      background-size: cover;
      opacity: 0.1;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute;
      z-index: -1;   
   }
   ._main-box {
      width: 900px;
      min-height: 300px;
      padding-top: 20px;
      padding-bottom: 20px;
      background-image: linear-gradient(164deg, #4A3EEA 0%, #473CD5 98%);
      box-shadow: 0 3px 13px 0 rgba(54,45,171,0.06);
      border-radius: 24px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
         width: calc(100% - 30px);
         flex-direction: column-reverse;
      }
      .introduction{
         width: calc(100% - 400px);
         display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: center;
         font-family: ${CONSTS.fonts.primary.medium};
         @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            width: calc(100% - 20px);
         }
         .portal-title {
            font-weight: 600;
            font-size: 1.1rem;
            color: white;
            margin-top: 25px;
            text-align: center;
            @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
               font-size: 1rem;
            }
         }
         .portal-description {
            font-weight: 200;
            font-size: .9rem;
            padding-left: 30px;
            padding-right: 30px;
            color: white;
            margin-top: 20px;
            text-align: center;
            @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
               display: none;
            }
         }
         .call-button {
            background-color: white;
            border-radius: 40px;
            padding: 10px 25px;
            color: ${CONSTS.colors.primary};
            text-align: center;
            font-size: 1rem;
            font-weight: 400;
            transform: scale(1);
            transition: ease all .25s;
            letter-spacing: -1px;
            margin-top: 20px;
            cursor: pointer;
            @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
               display: none;
            }
            &:hover {
               transform: scale(1.05);
            }
            &:active {
               transform: scale(1.01);
            }
         }
      }
         .login-box {
            width: 350px;
            display: inline-block;
            @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
               width: calc(100% - 20px);
               margin-top: 20px;
            }
            .responsive-call-button {
               display: none;  
               @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
                  display: block;
               }
            }
            .login-card {
               background: #FFFFFF;
               box-shadow: 0 15px 20px 0 rgba(63,63,68,0.1);
               border-radius: 12px;
               width: 100%;
               * {
                  box-sizing: border-box;
               }
               ._title-bar {
                  box-sizing: border-box;
                  font-family: ${CONSTS.fonts.primary.medium};
                  font-weight: 600;
                  font-size: 15px;
                  color: ${CONSTS.colors.primary};
                  text-align: center;
                  padding-top: 13px;
                  padding-bottom: 13px;
                  width: 100%;
                  border-bottom: 1px solid rgba(63,63,68,0.06);
               }
               form {
                  padding: 15px;
                  input {
                     outline: none;
                     min-height: 50px;
                     background: rgba(221,226,235,0.05);
                     width: 100%;
                     padding: 3px 15px;
                     font-family: ${CONSTS.fonts.primary.medium};
                     font-weight: 500;
                     font-size: 17px;
                     color: #1E1E3E;
                     border: 1px solid #DDE2EB;
                     border-radius: 8px;
                     transition: ease all .25s;
                     margin-top: 10px;
                     text-align: center;
                     &:first-child {
                        margin-top: 0px;
                     }
                     &::placeholder {
                        opacity: .5;
                     }
                     &:focus {
                        border-color: ${CONSTS.colors.primary};
                        background-color: ${CONSTS.colors.primaryLight};
                        color: ${CONSTS.colors.primaryDark};
                     }
                  }
               }
            }


         }
   }
`
const mapStateToProps = (state: AppState,ownProps: any) => ({
   
 });
 const mapDispatchToProps = (dispatch:any) => {
     return {
         onSetToken  : (token: string)      =>{
            dispatch(setToken(token));
         },
         onSetUser  : (user: any)      =>{
            dispatch(setUser(user));
         },
         onSetLab  : (lab: any)      =>{
            dispatch(setLab(lab));
         },
     };
   };
   
   export default withRouter(connect(
     mapStateToProps,
     mapDispatchToProps
   )(Login));
 